var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundedFrenchCuff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6325 53.2695C16.0335 41.1332 9.7563 30.4342 4.63471 37.9394C1.3311 44.6464 11.408 50.2354 23.6325 53.2695Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7455 47.1797C13.8184 36.7952 8.26182 33.2143 5.29541 36.9791L19.6675 22.7668C26.4405 20.2118 29.9097 29.4737 39.1607 38.2566L34.1926 44.315C24.9316 56.1319 24.1907 56.1319 19.7455 47.1797Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5024 22.7673L33.7093 6",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9951 38.0951L56.1755 21.9666",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6741 36.9796C41.5553 31.6867 43.8638 29.0712 48.0814 24.6836C44.5546 30.1919 42.4791 33.0977 38.3349 37.4586",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4759 44.8044L21.4847 45.7625L23.6322 47.3594L25.4494 45.6028L23.3018 44.0059L22.4759 44.8044ZM22.4759 44.8044L21.1543 43.5269",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6238 46.5588L25.7802 47.6767",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1279 22.7672C25.0547 20.8337 26.4407 19.254 28.5882 18.1362",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8567 34.9051C38.0478 33.4521 39.035 32.4465 40.317 30.2742",
    stroke: "#757575",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedFrenchCuff);
export default __webpack_public_path__ + "static/media/rounded_french_cuff.7182eb8fb845503191754e53e3e9ef2e.svg";
export { ForwardRef as ReactComponent };